import React, { Fragment, useState, useEffect } from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import {
  Breadcrumbs,
  Grid,
  Card,
  CardContent,
  Typography,
  Chip,
} from "@material-ui/core";
import { withStyles, makeStyles, createStyles } from "@material-ui/core/styles";
import HomeStyles from "pages/HomeStyles";
import {
  setCurrentPage,
  getHomePictreePhotoShootCommon,
  getPictreeDataPhotoShootTrendCommon,
  setPictreeChartSize,
} from "actions";
import * as C from "components";
import * as V from "styles/variables";
import PhotoShootCommon from "components/PicTree/Home/PhotoShootCommon";
import ChartConfig from "utils/ChartConfig";
import LineChartPictreePhotoShoot from "components/Charts/LineChartPictreePhotoShoot";
import PhotoShootTableCommon from "components/Table/PhotoShootTableCommon";
import SingleSelect from "components/Select/SingleSelect";
import CalendarRangePicTreeCommon from "components/Calendar/CalendarRangePicTreeCommon";

const useStyles = makeStyles((theme) =>
  createStyles({
    loaderBox: {
      width: "100%",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      minHeight: 280,
    },
    loaderBarImg: {
      width: 40,
    },
    breadcrumbs: {
      marginTop: 16,
      minHeight: 30,
    },
    gridSection: {
      marginTop: theme.spacing(1),
    },
    selectGameTxt: {
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      minHeight: 280,
      flexWrap: "wrap",
      "& > *": {
        margin: theme.spacing(0.5),
      },
    },
  })
);

const PicTreeReviewSummaryCommon = ({
  setCurrentPage,
  pageTopLoader,
  dateRangePicTreeCommon,
  getHomePictreePhotoShootCommon,
  photoShootTrend,
  getPictreeDataPhotoShootTrendCommon,
  setPictreeChartSize,
}) => {
  const classes = useStyles();
  const [chartState, setChartState] = useState(true);
  const [chartSize, setChartSize] = useState({ name: "日別", value: "day" });
  const [initialDataCall, setInitialDataCall] = useState(true);

  useEffect(() => {
    setCurrentPage(window.location.pathname);
  }, []);

  useEffect(() => {
    if (
      dateRangePicTreeCommon[0] !== null &&
      dateRangePicTreeCommon[1] !== null &&
      initialDataCall
    ) {
      getHomePictreePhotoShootCommon();
      getPictreeDataPhotoShootTrendCommon("day");
      setInitialDataCall(false);
    }
  }, [dateRangePicTreeCommon]);

  const handleChange = (event) => {
    setChartSize(event.target.value);
    setPictreeChartSize(event.target.value);
    getPictreeDataPhotoShootTrendCommon(event.target.value);
  };

  return (
    <Fragment>
      <C.ContentWrapper>
        <Grid
          container
          spacing={0}
          direction="row"
          style={{ marginTop: -16, marginBottom: 8 }}
          justifyContent="space-between"
        >
          <Grid item>
            <Breadcrumbs separator="›" className={classes.breadcrumbs}>
              <Typography>PicTrée 汎用事業者</Typography>
              <Typography variant="body1">撮影</Typography>
              <Typography variant="body1">概要</Typography>
            </Breadcrumbs>
          </Grid>
          <Grid item className={classes.fillRemailSpace}></Grid>
          <Grid item>
            <CalendarRangePicTreeCommon mDate={"2026/09/01"} page="pictree" pictree />
          </Grid>
        </Grid>

        <Grid container spacing={0} style={{ marginTop: 0 }}>
          <Grid item xs={12}>
            <Card>
              <CardContent>
                <div className={classes.cardContentSection}>
                  <PhotoShootCommon />
                </div>
              </CardContent>
            </Card>
          </Grid>
        </Grid>

        <Grid
          container
          spacing={0}
          direction="row"
          style={{ marginTop: 16, marginRight: 16, marginBottom: 8 }}
          justifyContent="space-between"
        >
          <Grid item style={{ marginTop: 0, marginLeft: 48 }}>
            <SingleSelect
              selected={chartSize}
              options={[
                { name: "時間別", value: "hour" },
                { name: "日別", value: "day" },
              ]}
              handleChange={handleChange}
            />
          </Grid>
          <Grid item>
            <Grid
              container
              spacing={0}
              direction="row"
              style={{ marginTop: 0, marginRight: 16, marginBottom: 8 }}
              justifyContent="flex-end"
            >
              <Grid item></Grid>
            </Grid>
          </Grid>
        </Grid>

        <>
          <Grid container spacing={1} className={classes.gridSection}>
            <Grid item xs={12} md={12} lg={12}>
              {pageTopLoader ? (
                <div className={classes.loaderBox}>
                  <img
                    className={classes.loaderBarImg}
                    src={`/static/images/loader-bar.gif`}
                  />
                </div>
              ) : chartState ? (
                photoShootTrend.length > 0 ? (
                  <LineChartPictreePhotoShoot
                    legend={["画像あり報告数", "画像なし報告数", "レビューOK機数", "撮影者数"]}
                    lblSaveImage={""}
                    xAisData={photoShootTrend[0]["date"]}
                    seriesData={photoShootTrend}
                    chartType={"line"}
                    chartConfig={{
                      countReportWithPhoto: "画像あり報告数",
                      countReportWithoutPhoto: "画像なし報告数",
                      countReviewOk: "レビューOK機数",
                      unique: "撮影者数",
                    }}
                    colorValue={ChartConfig.kpiSalesLegendColor}
                  />
                ) : (
                  <div className={classes.selectGameTxt}>
                    <Chip
                      label="No Data"
                      style={{
                        color: V.textColor,
                        backgroundColor: V.placeholderColor,
                      }}
                    />
                  </div>
                )
              ) : null}
            </Grid>
          </Grid>
          <Grid container spacing={1} className={classes.gridSection}>
            <Grid item xs={12} md={12} lg={12}>
              <PhotoShootTableCommon photoShootTrend={photoShootTrend} chartSize={chartSize.value} />
            </Grid>
          </Grid>
        </>
      </C.ContentWrapper>
    </Fragment>
  );
};

PicTreeReviewSummaryCommon.propTypes = {
  classes: PropTypes.object,
};

const mapStateToProps = (state) => ({
  pageTopLoader: state.page.pageTopLoader,
  dateRangePicTreeCommon: state.page.dateRangePicTreeCommon,
  photoShootTrend: state.pictreeCommon.photoShootTrend,
});

const mapDispatchToProps = (dispatch) => ({
  setCurrentPage: (param) => dispatch(setCurrentPage(param)),
  getHomePictreePhotoShootCommon: () => dispatch(getHomePictreePhotoShootCommon()),
  getPictreeDataPhotoShootTrendCommon: (param) => dispatch(getPictreeDataPhotoShootTrendCommon(param)),
  setPictreeChartSize: (param) => dispatch(setPictreeChartSize(param)),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withStyles(HomeStyles, { withTheme: true })(PicTreeReviewSummaryCommon));
